import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';


//TESTIMONIALS SLIDER START
const testimonialsSection = document.querySelectorAll('.section-testimonials');

if (testimonialsSection.length > 0){

    testimonialsSection.forEach(section=>{

        const sliderPrevButton = section.querySelector('.slider-prev');
        const sliderNextButton = section.querySelector('.slider-next');

        const sliderPrevButtonMobile = section.querySelector('.slider-prev-mobile');
        const sliderNextButtonMobile = section.querySelector('.slider-next-mobile');

        const slider = section.querySelector('.swiper')

        const swiperTestimonials = new Swiper(slider, {
            modules: [Navigation],
            direction: 'horizontal',
            loop: false,
            speed: 600,
            slidesPerView: 3,
            spaceBetween: 24,

            breakpoints: {
                320:{
                    slidesPerView: 1,
                    spaceBetween: 16,
                },
                768: {
                    slidesPerView: 2,
                    spaceBetween: 24,
                },
                1024: {
                    slidesPerView: 3,
                }
            },

            // Navigation arrows
            navigation: {
                nextEl: [sliderNextButton, sliderNextButtonMobile],
                prevEl: [sliderPrevButton, sliderPrevButtonMobile]
            }
        });
    })
}
//TESTIMONIALS SLIDER END

//TEAM SLIDER START

const teamSliderSections = document.querySelectorAll('.section-team-grid');

if (teamSliderSections.length > 0) {

    teamSliderSections.forEach(teamSection=>{
        const sliderPrevButton = teamSection.querySelector('.slider-prev');
        const sliderNextButton = teamSection.querySelector('.slider-next');

        const sliderPrevButtonMobile = teamSection.querySelector('.slider-prev-mobile');
        const sliderNextButtonMobile = teamSection.querySelector('.slider-next-mobile');

        const slider = teamSection.querySelector('.swiper')

        const swiperTeam = new Swiper(slider, {
            modules: [Navigation],
            // Optional parameters
            direction: 'horizontal',
            loop: false,
            spaceBetween: 24,
            speed: 600,

            breakpoints: {
              320:{
                  slidesPerView: 1,
                  spaceBetween: 16,
              },
              640: {
                  slidesPerView: 2,
                  spaceBetween: 24,
              },
              1024: {
                  slidesPerView: 3,
              },
              1200: {
                  slidesPerView: 4
              }
            },

            // // Navigation arrows
            navigation: {
                nextEl: [sliderNextButton, sliderNextButtonMobile],
                prevEl: [sliderPrevButton, sliderPrevButtonMobile]
            }
        });
    })


}

//TEAM SLIDER END


//OFFERS SLIDER START

const offersSliderSections = document.querySelectorAll('.section-offers-slider');

if (offersSliderSections.length > 0) {

    offersSliderSections.forEach(offersSection=>{
        const sliderPrevButton = offersSection.querySelector('.slider-prev');
        const sliderNextButton = offersSection.querySelector('.slider-next');

        const sliderPrevButtonMobile = offersSection.querySelector('.slider-prev-mobile');
        const sliderNextButtonMobile = offersSection.querySelector('.slider-next-mobile');

        const slider = offersSection.querySelector('.swiper')

        const swiperOffers = new Swiper(slider, {
            modules: [Navigation],
            direction: 'horizontal',
            loop: false,
            speed: 500, 

            breakpoints: {
                320:{
                    slidesPerView: 1,
                    spaceBetween: 24,
                },

                1024: {
                    slidesPerView: 1.25,
                    spaceBetween: 24,
                }   
            },

            
              // Navigation arrows
              navigation: {
                nextEl: [sliderNextButton, sliderNextButtonMobile],
                prevEl: [sliderPrevButton, sliderPrevButtonMobile]
            }
        })
    })
}
//OFFERS SLIDER END
